import { useTranslation } from 'react-i18next';
import { Badge } from 'reactstrap';

import { TranslationsKeys } from '../../../../locales/translations';

export type CourseStatus = 'pending' | 'approved' | 'rejected';

const STATUS_COLORS: Record<CourseStatus, string> = {
  pending: '#E0EEFD',
  approved: '#CEF0DA',
  rejected: '#FDDFDF',
};

export default function CourseStatusBadge({
  status,
}: {
  status: CourseStatus;
}) {
  const { t } = useTranslation(TranslationsKeys.HOMOLOGATION_DETAIL);

  return (
    <Badge
      pill
      className="fs-16 fw-400 py-2 px-4 text-dark"
      style={{ backgroundColor: STATUS_COLORS[status], width: 121 }}
    >
      {t(`courseStatus.${status}`)}
    </Badge>
  );
}
